export default defineNuxtPlugin(async () => {
  const equipment = useEquipmentStore();
  const route = useRoute();
  const user = useUserStore();

  const headers = useRequestHeaders(["user-agent"]);
  let userAgent = headers["user-agent"] as string;
  equipment.initAppByDevice(userAgent);
});
